import { computed } from 'vue';

import { GlobalState } from '@/global';
import { needsSmsRegistration } from '@/modules/talk/helpers/messaging';
import { DataCache } from '@/shared/data/cache';
import { hasPermission } from '@/shared/helpers/permissions.helpers';

/**
 * Whether a number is waiting on a 10DLC registration the tenant has not filed yet.
 *
 * The number sits `pending` from the moment messaging is requested, so pending alone says nothing
 * about whose move it is; a null `messagingCampaignStatus` is what means no registration has been
 * submitted for it. That is the tenant's move, and the form is on the ZynoTalk overview — hence the
 * dot there.
 *
 * Same shape as `isTalkOnboardingActive`: gated on tenant-admin + Talk, reading a shared cache entry
 * lazily so a nav dot never provokes the request on its own.
 */
export const talkNeedsSmsRegistration = computed<boolean>(() => {
    if (!GlobalState.tenant.value?.isAdmin || !hasPermission('talk')) return false;
    const numbers = DataCache.getLazyRef('talkNumbers').value;
    return !!numbers && needsSmsRegistration(numbers.filter(n => !n.deletedAt));
});

/** Returns the shared flag, kicking the (gated, deduped) load if it hasn't run yet. */
export function useTalkNeedsSmsRegistration() {
    if (GlobalState.tenant.value?.isAdmin && hasPermission('talk')) DataCache.getRef('talkNumbers');
    return talkNeedsSmsRegistration;
}
